import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgRemove({
  className,
  "data-test-id": dataTest = "IconRemove",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M9.167 8.367a.523.523 0 0 0-.73-.004l-.074.074c-.2.2-.2.526.004.73L11.2 12l-2.833 2.833a.523.523 0 0 0-.004.73l.074.074c.2.2.526.2.73-.005l2.824-2.841 2.84 2.84a.523.523 0 0 0 .732.006l.074-.074c.2-.2.2-.527-.005-.731l-2.843-2.843 2.807-2.823a.538.538 0 0 0 .002-.747l-.036-.038a.505.505 0 0 0-.73-.014L12 11.2 9.167 8.367z" }) }) });
}));
